export default {
    openSchedulingAssistant: {
        name: 'OPEN_SCHEDULING_ASSISTANT',
    },
};
